import { useStyletron } from "baseui";
import { ListItem, ListItemLabel } from "baseui/list";
import {
  useGetResourceGroupBacnetDevicesQuery,
  useGetResourceGroupsQuery,
} from "../../services/resourceGroups/resourceGroupApi";
import { Button } from "baseui/button";
import { ChevronRight } from "baseui/icon";
import { VscSymbolClass } from "react-icons/vsc";
import { Items } from "../resourceGroup/Items";
import { LoadingView } from "../../components/LoadingView";
import { HorizontalStackPanel, VerticalStackPanel } from "../../components/Layout/StackPanel";
import { ParagraphXSmall } from "baseui/typography";
import { IoHardwareChipOutline } from "react-icons/io5";
import { IResourceGroup } from "@oqdo/automationapps/Memberships/ResourceGroup";
import { Badge } from "baseui/badge";

type ResourceGroupsViewProps = {
  subscriptionId: string;
};

const ResourceGroupsView = ({ subscriptionId }: ResourceGroupsViewProps) => {
  const [css, theme] = useStyletron();
  const { data, isLoading, error, isSuccess } = useGetResourceGroupsQuery({
    subscriptionId: subscriptionId,
    page: 0,
    pageSize: 1000,
  });
  const rgs = data?.data;
  return (
    <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
      {rgs?.map((item: IResourceGroup, index) => (
        <ResourceGroupItem key={item.id} resourceGroup={item} subscriptionId={subscriptionId} />
      ))}
    </LoadingView>
  );
};

export default ResourceGroupsView;

const ResourceGroupItem = (props: { resourceGroup: IResourceGroup; subscriptionId: string }) => {
  const rg = props.resourceGroup;
  const [css, theme] = useStyletron();
  const { data: bacnetDevices } = useGetResourceGroupBacnetDevicesQuery(rg.id);
  //const { data: ahus } = useGetResourceGroupAHUOptimizersQuery(rg.id)

  return (
    <>
      {rg && (
        <ListItem
          shape="ROUND"
          artwork={() => <VscSymbolClass color={theme.colors.primary} />}
          key={rg.id}
          endEnhancer={() => (
            <HorizontalStackPanel>
              <VerticalStackPanel>
                <HorizontalStackPanel $flexWrap={"nowrap"}>
                  <ParagraphXSmall margin={0}>
                    <IoHardwareChipOutline /> <b>{bacnetDevices?.length}</b> {"phys. BACnet Device(s)"}
                  </ParagraphXSmall>
                </HorizontalStackPanel>
              </VerticalStackPanel>
              <Button
                $as="a"
                href={`/subscriptions/${props.subscriptionId}/resourceGroups/${rg.id}`}
                kind="tertiary"
                shape="circle">
                <ChevronRight size="scale800" />
              </Button>
            </HorizontalStackPanel>
          )}
          overrides={{
            Root: {
              style: ({ $theme }) => ({
                backgroundColor: rg.disabled ? $theme.colors.backgroundSecondary : undefined,
              }),
            },
          }}>
          <ListItemLabel description={<Items resourceGroup={rg} />}>
            <>
              {rg.name} {rg.disabled && <Badge content="Disabled" color="primary" shape="pill" />}
            </>
          </ListItemLabel>
        </ListItem>
      )}
    </>
  );
};
